export const api = 'https://kaushik.onrender.com/api/v1';
